import { Box, Button, Caption, Heading, Revert, ToggleSwitch } from "@bcc-ui/ui-components";
import classNames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";

import style from "./smart-grading-banner.scss";
import { GradingStep, toStepperNumber } from "services/asset-management/AssetGradingService";

import testIds from "testIds.json";

interface Props {
    currentStepNumber: number;
    isSmartGradingEnabled: boolean;
    eligibleAssetsCount: number;
    onSmartGradingChange: (value: boolean) => void;
    onGradingStepSave: (step: GradingStep, enabled: boolean) => void;
    isRerunAllowed?: boolean;
    handleRerunGrading?: () => void;
}

export const SmartGradingBanner = (props: Props) => {
    const { t } = useTranslation();

    if (props.currentStepNumber === 1) {
        return null;
    }

    return (
        <Box
            paddingTop={"Xs"}
            paddingRight={"Sm"}
            paddingBottom={"Xs"}
            paddingLeft={"Sm"}
            justifyContent={"SpaceBetween"}
            verticalAlignment={"Center"}
            className={style.smartGradingBanner}
        >
            <Box columnLayout flexWrap={"Wrap"}>
                <Heading variant={"SUBTITLE_1"} disableBottomSpacing disableTopSpacing>
                    {t("AssetManagement.value.smartGrading.bannerTitle")}
                </Heading>
                <Caption className={style.captionTextColor}>
                    {t("AssetManagement.value.smartGrading.bannerContent")}
                </Caption>
            </Box>
            <Box gap="Sm" verticalAlignment="Center">
                {props.currentStepNumber === toStepperNumber(GradingStep.VALUE_RECOVERY) && (
                    <Button
                        variant="Tertiary"
                        icon={
                            <Revert
                                className={style.restartGradingIcon}
                                color={"--app-smart-grading-banner-button-color"}
                            />
                        }
                        disabled={!props.isRerunAllowed}
                        onClick={props.handleRerunGrading}
                        className={style.restartGradingButton}
                        title={
                            !props.isRerunAllowed ? t("AssetManagement.value.smartGrading.rerun.notAllowed") : undefined
                        }
                    >
                        {t("AssetManagement.value.smartGrading.rerun.title")}
                    </Button>
                )}
                <ToggleSwitch
                    testIds={{ input: testIds.workArea.asset.customView.value.smartGradingToggle }}
                    className={classNames(style.smartGradingToggleSwitch, {
                        [style.disabledToggle]: props.eligibleAssetsCount === 0,
                    })}
                    hideLabelSection
                    disabled={props.currentStepNumber === toStepperNumber(GradingStep.WORKFLOW_INTEGRATION_STARTED)}
                    defaultChecked={props.isSmartGradingEnabled}
                    type={"checkbox"}
                    name={"smartGradingEnabledBanner"}
                    onChange={(e) => {
                        props.onSmartGradingChange(e.target.checked);
                        props.onGradingStepSave(GradingStep.SMART_GRADING_STARTED, e.target.checked);
                    }}
                />
            </Box>
        </Box>
    );
};
